import AddCircleIcon from "@mui/icons-material/AddCircle";

export default function CreateActivity({ active, onClick, mainClass = "" }) {
  return (
    active && (
      <div className={mainClass}>
        <AddCircleIcon
          className={"addActivity"}
          fontSize="large"
          onClick={onClick}
        />
      </div>
    )
  );
}
